const map = {
	"./1.png": 7390,
	"./10.png": 7884,
	"./11.png": 149,
	"./12.png": 2318,
	"./13.png": 1815,
	"./14.png": 9672,
	"./15.png": 801,
	"./16.png": 9722,
	"./17.png": 5283,
	"./18.png": 9364,
	"./19.png": 493,
	"./2.png": 4117,
	"./20.png": 8305,
	"./21.png": 4088,
	"./22.png": 5715,
	"./23.png": 8138,
	"./24.png": 4645,
	"./25.png": 5548,
	"./26.png": 5607,
	"./27.png": 7294,
	"./28.png": 6201,
	"./29.png": 5024,
	"./3.png": 2492,
	"./30.png": 5302,
	"./31.png": 3391,
	"./32.png": 9828,
	"./4.png": 1891,
	"./5.png": 2058,
	"./6.png": 1953,
	"./7.png": 3560,
	"./8.png": 6975,
	"./9.png": 3174
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9796;